/* Cómo se dice el rol de una persona.
 *
 * ── SALE DE LA PLANILLA, NO DE LA HERENCIA DE CANTAPP ──────────────────────
 *
 * Había dos vocabularios que no se hablaban: `public.users.rol` —heredado de
 * CantApp, con `dev` / `user` / `usuario` / `admin` / `superadmin`, cuatro
 * palabras para tres cosas y una duplicada en dos idiomas— y la columna Rol de
 * la planilla, que es como la gente se nombra adentro de la empresa.
 *
 * El hub mostraba el primero, y por eso alguien figuraba con un puesto que ya
 * no tiene. La planilla es la que ALGUIEN MANTIENE; el otro es un campo que se
 * llenó una vez al migrar y nadie volvió a tocar.
 *
 * ── «SIN FILA EN LA PLANILLA» NO SE DICE COMO «SIN PERFIL» ─────────────────
 *
 * Antes las dos cosas se dibujaban igual —«sin perfil»— y mandan a hacer cosas
 * opuestas: una se arregla escribiendo un renglón en la planilla del Drive, y
 * la otra no se arregla porque no está rota. El que las lee iguales no sabe a
 * cuál de las dos ir.
 *
 * Y el rol viejo NO se usa de reemplazo. Poner algo para que la celda no quede
 * vacía es exactamente lo que hizo falta arreglar: se ve lleno, se cree, y
 * nadie va a corregir la planilla.
 */

export const SIN_PLANILLA = "sin fila en la planilla";

/* El rol para mostrar. `persona` es lo que devuelve `permisos_de_todos()`. */
export function rolDe(persona) {
  if (!persona) return SIN_PLANILLA;
  const rol = String(persona.rol ?? "").trim();
  if (rol) return rol;
  /* `en_planilla` distingue los dos huecos: tiene fila y la celda Rol está
   * vacía, o no tiene fila. El primero es un dato que falta en un renglón que
   * existe; el segundo, un renglón que no existe. */
  return persona.en_planilla ? "sin rol cargado" : SIN_PLANILLA;
}

/* `true` cuando lo que se está mostrando es un hueco y no un rol. La pantalla
 * lo dibuja en gris: un hueco con el mismo peso que un dato se lee como dato. */
export const esHueco = (persona) => !String(persona?.rol ?? "").trim();

/* ¿Esta persona tiene tal rol? Contra los roles YA PARTIDOS que manda la base
 * —«Admin-taller» son tres—, que salen de `roles_de` en FlotaBot. Repartir el
 * parteo acá haría que el hub y el bot dijeran cosas distintas de la misma
 * persona el día que cambie cómo se parte una celda. */
export function tieneRol(persona, rol) {
  const buscado = String(rol ?? "").trim().toLowerCase();
  if (!buscado) return false;
  return (persona?.roles || []).some(
    (r) => String(r).trim().toLowerCase() === buscado,
  );
}
